import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CORGI_ALLOW_IFRAME_EMBEDDING = defineFcm('corgi_allow_iframe_embedding')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			shape: {
				type: 'object',
				shape: {
					allowedAncestorDomains: {
						type: 'array',
						shape: { type: 'string' },
					},
				},
			},
		}),
	)
	.withDefault({})
	.toConfig();
